import React from 'react';
import Layout from '../../../Layout';
import Photos from "./photos";


const index = () => {
  return (
    <Layout>
      <Photos />
    </Layout>
  )
}

export default index;